import { ModelFactory } from "../../ModelFactory"

export type Permission = "view" | "edit" | "delete" | "create"
export interface PermissionMap {
  [key: string]: Permission[]
}

/** Backend capability keys and the resource names the frontend uses for them. */
const resourceKeys: Record<string, string> = {
  authorized_keys: 'authorizedKeys',
  contracts: 'contracts',
  customers: 'customers',
  customer_contacts: 'customerContacts',
  customer_logins: 'customerLogins',
  deployments: 'deployments',
  domains: 'domains',
  domain_dns: 'dns',
  domain_auth: 'domainAuth',
  notes: 'notes',
  servers: 'servers',
  sites: 'sites',
  mail: 'mail',
  certificates: 'certificates',
  roles: 'roles',
}

class PermissionMapFactory extends ModelFactory<PermissionMap> {
  protected fromJson(json: any): PermissionMap {
    return Object.fromEntries(Object.entries(resourceKeys).map(([key, resource]) => [resource, json[key] ?? []]))
  }
}
export const permissionMapFactory = new PermissionMapFactory()

/**
 * The permissions the backend sends with a single item. Only the resources it sends are included, so `can()` falls
 * back to the capabilities for the others.
 */
export const parseItemPermissions = (json: any): PermissionMap | null => {
  if (!json) {
    return null
  }
  return Object.fromEntries(Object.entries(resourceKeys).filter(([key]) => key in json).map(([key, resource]) => [resource, json[key]]))
}
